'use client';
import styled from 'styled-components';

export const StyledUploadImageContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`;

export const StyledButtonContainer = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing(2)};
  @media ${({ theme }) => theme.tabletL} {
    max-width: 477px;
  }
`;

export const StyledCaptureInput = styled.input`
  display: none;
`;

export const StyledReviewContainer = styled.div`
  width: 100%;
  padding: 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media ${({ theme }) => theme.tabletL} {
    width: 30rem;
    padding: 32px 72px;
  }
`;
export const StyledReviewImageContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(10)};
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    border-radius: 32px;
    width: auto;
    height: 8rem;
  }
  height: 8rem;

  @media ${({ theme }) => theme.tablet} {
    height: 15rem;
    img {
      height: 15rem;
    }
  }

  @media ${({ theme }) => theme.tabletL} {
    margin-top: 0;
  }
`;

export const StyledReviewTitle = styled.h3`
  ${({ theme }) => theme.fontFamily.base}
  color: #000;
  text-align: center;
  padding: 24px 0;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 38px; /* 118.75% */
  letter-spacing: 0.32px;
`;
export const StyledReviewListTitle = styled.h3`
  ${({ theme }) => theme.fontFamily.condensed}
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 20px; /* 100% */
  letter-spacing: 0.2px;
  text-transform: uppercase;
  width: 100%;
  margin-bottom: 20px;
`;

export const StyledList = styled.div`
  width: 100%;
  padding-left: 8px;
  margin-bottom: 1rem;
`;
export const StyledListItems = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const StyledListItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 14px;
`;
export const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  background-color: ${({ theme }) => theme.colors.secondary.egg};
  border-radius: 1rem;
`;
export const StyledListItemText = styled.div`
  ${({ theme }) => theme.fontFamily.base}
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 16px;
  font-weight: 600;
  line-height: 26px; /* 162.5% */
  letter-spacing: 0.16px;
`;

export const ErrorTextWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(4)};
  text-align: center;
`;
